module.exports = __webpack_public_path__ + "media/images/categories/headers/government-and-law-8dea1ea6f11a9cbbab0a4b969321e192.jpg";